import PropTypes from 'prop-types';
import styled from 'styled-components';
import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

import { Button } from '@companycam/slab-web';
import { TemplateModalContext } from '../TemplateModalContext';

import { graphQLIdDecoder } from 'helpers/graphql-utils';
import { ADMIN, MANAGER, hasRoleAccess } from 'helpers/roles';
import { previousView, setCurrentTemplateId } from 'actions/todos';
import { useCurrentUser } from 'javascripts/hooks';

// #region styled-components

const RightButtons = styled.div`
  display: flex;
  gap: 12px;
`;
const ButtonDiv = styled.div`
  justify-self: flex-start;
  flex: 1;
  display: flex;
  padding-left: 8px;
`;

// #endregion

const FooterButtons = ({
  createTaskListFromTemplate,
  isLoading,
  ownsTemplate,
  onRequestClose,
}) => {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const { projectNodeId } = useContext(TemplateModalContext);
  const { databaseId: projectId } = graphQLIdDecoder(projectNodeId);
  const user = useCurrentUser();
  const hasManagePermissions = hasRoleAccess(user, [ADMIN, MANAGER]);

  const currentTemplateId = useSelector(
    ({ todos }) => todos.templates.currentTemplateId,
  );

  const navigateToEditTemplate = () => {
    onRequestClose();
    window.Turbo.visit(
      `/todos/templates/edit/${currentTemplateId}?projectId=${projectId}`,
    );
  };

  return (
    <>
      <RightButtons>
        {hasManagePermissions && ownsTemplate ? (
          <Button
            color="subtle"
            icon={{
              name: 'pencil',
              position: 'before',
            }}
            onClick={navigateToEditTemplate}
            ariaLabel={formatMessage({
              id: 'Projects.taskList.templates.edit',
            })}
          >
            {formatMessage({ id: 'Projects.taskList.templates.edit' })}
          </Button>
        ) : null}
        <Button
          color="primary"
          icon={{
            name: 'plus',
            position: 'before',
          }}
          onClick={createTaskListFromTemplate}
          disabled={isLoading}
          loading={isLoading}
          ariaLabel={formatMessage({
            id: 'Projects.taskList.templates.useTemplate',
          })}
        >
          {formatMessage({
            id: 'Projects.taskList.templates.useTemplate',
          })}
        </Button>
      </RightButtons>
      {hasManagePermissions && ownsTemplate ? (
        <ButtonDiv>
          <Button
            color="subtle"
            design="minimal"
            onClick={() => {
              dispatch(setCurrentTemplateId(null));
              dispatch(previousView());
            }}
            aria-label={formatMessage({ id: 'Common.cancel' })}
          >
            {formatMessage({ id: 'Common.cancel' })}
          </Button>
        </ButtonDiv>
      ) : (
        <Button
          color="subtle"
          onClick={() => {
            dispatch(setCurrentTemplateId(null));
            dispatch(previousView());
          }}
          ariaLabel={formatMessage({ id: 'Common.cancel' })}
        >
          {formatMessage({ id: 'Common.cancel' })}
        </Button>
      )}
    </>
  );
};

FooterButtons.propTypes = {
  createTaskListFromTemplate: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func,
  ownsTemplate: PropTypes.bool,
};

export default FooterButtons;
